module.exports = __webpack_public_path__ + "static/media/notification.7d8c5d58.mp3";